
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"62","height":"113","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3.357 53.654a4.355 4.355 0 003.66 1.994h13.677L.244 107.052c-.238 2.05.038 4.385 1.983 5.43.654.35 1.728.518 2.06.518a4.355 4.355 0 003.573-1.86l52.383-74.821c.926-1.511 1.038-3.244.288-4.678a4.354 4.354 0 00-3.86-2.335h-13.47l10.37-23.19c.6-1.345.48-2.901-.324-4.136A4.354 4.354 0 0049.596 0H28.552c-1.808 0-3.357.994-4.064 2.543L3.056 49.57c-.613 1.277-.5 2.84.3 4.084z","fill":"#F6E94A"}})])
          )
        }
      }
    